import axios from "axios";

// The scheduled compliance reports are emailed in the language the user
// last used the app in. The backend has no other way to know it: the job
// read a `language` column the users table does not have, so every
// scheduled report was English.
let synced = null;

export function reportLanguageCode(lang) {
  return String(lang || "").toLowerCase().startsWith("fr") ? "fr" : "en";
}

export async function syncReportLanguage(userId, lang) {
  if (!userId) return;
  const code = reportLanguageCode(lang);
  const key = `${userId}:${code}`;
  if (synced === key) return;
  synced = key;
  try {
    await axios.put("/api/reporting/preferences/language", { lang: code });
  } catch {
    synced = null; // retried on the next change or load
  }
}

export function resetReportLanguageSync() {
  synced = null;
}
